import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../services/authentication/authentication.service";

@Component({
  selector: "app-logout",
  template: "",
})
export class LogoutComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  public menuItems: any[];

  ngOnInit() {
    this.authenticationService.logout();
    // this.router.navigateByUrl("/", { skipLocationChange: true, state: {} });

    window.location.href = "/";
  }
}
